// extracted by mini-css-extract-plugin
export default {"a11yFocus":"xm0Dt","a11YFocus":"xm0Dt","mainHeader":"Q0eBe","centered":"Xl33f","logosContainer":"zQMF2","headerHeight":"RYEiS","backButtonContainer":"DDWXF","backButton":"e-w4E"};